export const tutorAvailabilityLoading =  ({store})  => store.tutorAvailabilityReducer.loading;

export const tutorAvailabilityError =  ({store})  => store.tutorAvailabilityReducer.error;

export const tutorAvailabilityData =  ({store})  => store.tutorAvailabilityReducer.data;